import { Component } from 'react';
import { Button } from '@mui/material';
export class NineAssetCards extends Component {
    render(){
        return (
            <div>
                <p>
                    <Button variant="contained" color="primary">Default</Button>
                </p>
                <p>
                    {'ui-components/NineAssetCards'}
                </p>
            </div>
        )
    }
}
